<div class="idms_tree_view">
    <div *ngIf="idmstagItem" class="px-10">
        <app-nested-render [fullHierarchy]="filterByInstance(idmstagItem)" [idmsHierarchy]="returnIdmsHierarchy()"></app-nested-render>
    </div>
</div>
